import Navbar from "@/components/landing/Navbar";
import HeroSection from "@/components/landing/HeroSection";
import FeaturesSection from "@/components/landing/FeaturesSection";
import HowItWorksSection from "@/components/landing/HowItWorksSection";
import SocialProofSection from "@/components/landing/SocialProofSection";
import PricingSection from "@/components/landing/PricingSection";
import CtaSection from "@/components/landing/CtaSection";
import FooterSection from "@/components/landing/FooterSection";
import SeoHead from "@/components/SeoHead";
import { usePlatformConfig } from "@/hooks/usePlatformConfig";

const Index = () => {
  const { config } = usePlatformConfig();

  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "ViaMenu",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    description: "Plataforma completa para digitalizar e gerenciar restaurantes: cardápio digital, QR Code, delivery, PDV e gestão financeira.",
    url: "https://viamenu.com.br",
    offers: { "@type": "Offer", price: "0", priceCurrency: "BRL" },
    aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "150" },
  };

  return (
    <div className="min-h-screen bg-background">
      <SeoHead
        title="ViaMenu — Cardápio Digital e Gestão Completa para Restaurantes"
        description="Plataforma SaaS completa para restaurantes, pizzarias, lanchonetes e bares. Cardápio digital com QR Code, delivery próprio, PDV, painel da cozinha e gestão financeira. Teste grátis por 30 dias."
        canonicalUrl="https://viamenu.com.br/"
        keywords={["cardápio digital", "cardápio online", "sistema para restaurante", "delivery próprio", "menu digital", "qr code restaurante", "sistema pizzaria", "sistema lanchonete", "pdv restaurante", "gestão de restaurante"]}
        schemaMarkup={schemaMarkup}
      />
      <Navbar />
      <HeroSection />
      {config.show_features_section && <FeaturesSection />}
      {config.show_how_it_works_section && <HowItWorksSection />}
      {config.show_social_proof_section && <SocialProofSection />}
      {config.show_pricing_section && <PricingSection />}
      {config.show_cta_section && <CtaSection />}
      <FooterSection />
    </div>
  );
};

export default Index;
